import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Contact from './views/Contact.vue'
import Registration from './views/Registration.vue'
import Login from './views/Login.vue'
import Signup from './views/Signup.vue'
import Profile from './views/Profile.vue'
import NotFound from './views/NotFound.vue'
import NewUser from './views/NewUser.vue'
import RequestKey from './views/RequestKey.vue'
import Order from './views/Order.vue'
import store from '@/store/store';


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/schedule',
      name: 'Register',
      props: true,
      component: Registration,
      alias: '/registration'
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/login',
      name: 'Log',
      component: Login
    },
    {
      path: '/Signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/Order',
      name: 'Order',
      component: Order
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/newUser',
      name: 'NewUser',
      component: NewUser
    },
    {
      path: '/requestKey',
      name: 'RequestKey',
      component: RequestKey
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})

export default router;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.auth.isLoggedIn) {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      next()
    } 
  } else {
    next()
  }
})